<template>
  <div class="grid-x grid-margin-x small-margin-bottom-xl large-margin-bottom-xxl">
    <div v-if="isMobile" class="cell title-mobile padding-bottom-xs">
      <ProductTitle />
      <ReviewRating />
    </div>
    <div :class="cellLeft">
      <Media />
    </div>
    <div :class="cellRight">
      <div v-if="!isMobile" class="title">
        <ProductTitle />
        <ReviewRating />
      </div>
      <UnavailableProductDetails />
      <LazyLoadWhenInViewport>
        <SponsoredItemTop
          v-if="showSponsoredItemTop"
          :enable-click-tags-for-s-m-products="killswitches.enableClickTagsForSMProducts"
          :is-simplification-mcom-on="killswitches.priceSimplificationEnabled"
        />
      </LazyLoadWhenInViewport>
    </div>
    <div class="cell large-12" data-testid="product-details-section">
      <ProductDetails :class="{ 'margin-top-xl': !isMobile && !showSponsoredItemTop }" />
    </div>
  </div>
  <LazyLoadWhenInViewport v-if="isBcom" :root-margin="0" data-testid="lazy-pros-zone-a">
    <ProsUnavailableZoneA />
  </LazyLoadWhenInViewport>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';

import { useDeviceType } from '~/composables/utils/useDeviceType';
import { useBrand } from '~/composables/useBrand';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import useKillswitches from '~/modules/featureControl/composables/useKillswitches';
import useGridLayoutConfig from '~/composables/useGridLayoutConfig';

import SponsoredItemTop from '@nuxt-common/site-monetization/app/components/SponsoredItemTop.vue';
import LazyLoadWhenInViewport from '~/components/common/LazyLoadWhenInViewport.vue';
import StaticImportProductDetails from '~/modules/productDetails/components/ProductDetails.vue';
import LazyHydratedProductDetails from '~/modules/lazy-hydration/components/ProductDetails.vue';
import ProductTitle from '~/components/productTitle/ProductTitle.common.vue';
import ReviewRating from '~/modules/reviews/components/ReviewRating.vue';
import Media from '~/components/common/Media/Media.vue';
import UnavailableProductDetails from './UnavailableProductDetails.vue';

const ProsUnavailableZoneA = defineAsyncComponent(() => import('~/modules/pros/ProsUnavailableZoneA.vue'));

const { killswitches } = useKillswitches();
const { isMobile } = useDeviceType();
const { showSponsoredItemTop } = useFeatureEligibility();
const { isBcom } = useBrand();

const { cellLeft, cellRight } = useGridLayoutConfig();

let ProductDetails = StaticImportProductDetails;
// TODOS: remove later once lazy hydration testing is over
if (killswitches.isLazyHydrationEnabled) {
  ProductDetails = LazyHydratedProductDetails;
}
</script>




<style lang="scss" scoped>
@import '~settingSCSS';
@include title;
</style>